import { AddJobStep1Details } from "../../types/addJobStep1Details";
import { JobPendingStepOneRequest } from "../controllers/jobs";

export const convertAddJobStep1DetailsRequest = (
    data: AddJobStep1Details
): JobPendingStepOneRequest => {
    if (!data) return null;

    const step1: JobPendingStepOneRequest = {
        teamId: data.teamId,
        externalDescription: data.externalDescription,
        attachmentId: data.attachment?.fileId,
        jobConcurrencyToken: data.jobConcurrencyToken,
    };
    return step1;
};
